import { hideBlocksWithResults, replaceDiagnosticLinks } from "./theme/diagnostic-links.js";
import { fixHeaderWithPadding, toggleHeaderOnScroll } from "./theme/header.js";
import { rafThrottle } from "./theme/utils.js";
import { syncDiscountFromQueryToCookie } from "./quiz/quiz-results-discount.js";

function initDiscountFromQuery() {
  void syncDiscountFromQueryToCookie();
}
function initRechargeSubscriptionWidget() {
    
    
    if (!window.SUBSCRIPTION_PRICE || !window.SUBSCRIPTION_DISCOUNT_PERCENT) return;

    function injectBadge(shadow) {
      
      const onetimeBlock = shadow.querySelector('.rc-selection__onetime');

      if (!onetimeBlock) return;

      if (onetimeBlock.querySelector('.rc-purchase-option__badge')) return;

      const badge = document.createElement('span');
      badge.classList.add('rc-purchase-option__badge');
      badge.textContent = SUBSCRIPTION_DISCOUNT_PERCENT;

      onetimeBlock.appendChild(badge);
    }

    function injectStrikePrice(shadow) {
      const pricesBlock = shadow.querySelector('.rc-purchase-option__prices');

      if (!pricesBlock) return;

      if (pricesBlock.querySelector('.strike-through')) return;

      const strikePrice = document.createElement('span');
      strikePrice.classList.add('rc-price', 'strike-through', 'text-muted');
      strikePrice.textContent = SUBSCRIPTION_PRICE;

      pricesBlock.prepend(strikePrice);
    }

    function initObserver() {
      const widget = document.querySelector('recharge-subscription-widget');

      if (!widget) return;

      function attachToShadowRoot() {
        const shadow = widget.shadowRoot;

        if (!shadow) {
          requestAnimationFrame(attachToShadowRoot);
          return;
        }

        // Run once on initial render
        injectBadge(shadow);
        injectStrikePrice(shadow);

        function onWidgetMutated(mutations) {
          for (const mutation of mutations) {
            if (mutation.type === 'childList' || mutation.type === 'characterData') {
              injectBadge(shadow);
              injectStrikePrice(shadow);
            }
          }
        }

        const observer = new MutationObserver(onWidgetMutated);

        observer.observe(shadow, {
          childList: true,
          subtree: true,
          characterData: true,
        });
      }

      attachToShadowRoot();
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initObserver);
    } else {
      initObserver();
    }
    
  }

const GLOBAL_INITIALIZERS = [
  fixHeaderWithPadding,
  toggleHeaderOnScroll,
  replaceDiagnosticLinks,
  hideBlocksWithResults,
  initDiscountFromQuery,
  initRechargeSubscriptionWidget,
];

document.addEventListener("DOMContentLoaded", () => {
  GLOBAL_INITIALIZERS.forEach((init) => {
    try {
      init();
    } catch (_error) {
      // Keep independent initializers from breaking global bootstrap.
    }
  });
});

window.addEventListener(
  "resize",
  rafThrottle(() => {
    fixHeaderWithPadding();
  }),
);
